import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Home, CircleDollarSign, MessageCircleCodeIcon, MessageCircleHeart, Menu } from 'lucide-react';
import AppContext from '../Context/AppContext';
import { useSocket } from '../Context/SocketContext';
import { useSupport } from '../Context/SupportContext';

/** Mobile : les pages les plus utilisées + « Menu » (tout le menu, rangé par thème). */
const BottomNav = ({ onMenu = () => { } }) => {
    const { currentPage } = useContext(AppContext)
    const { notifAskPaiement, messageUser } = useSocket()
    const { unread: supportUnread } = useSupport()

    const items = [
        { to: "/", page: "homepage", label: "Accueil", Icon: Home },
        { to: "/paiement", page: "paiement", label: "Paiements", Icon: CircleDollarSign, dot: !!notifAskPaiement },
        { to: "/message_user", page: "message_user", label: "Messages", Icon: MessageCircleCodeIcon, dot: !!messageUser },
        { to: "/support_plateformes", page: "support_plateformes", label: "Support", Icon: MessageCircleHeart, dot: supportUnread > 0 },
    ]

    return (
        <nav className='bottom-nav'>
            {items.map(({ to, page, label, Icon, dot }) => {
                const active = currentPage === page
                return (
                    <Link key={page} to={to} className={`bn-item ${active ? "active" : ""}`}>
                        <Icon size={24} color={active ? '#fff' : '#8f909c'} />
                        <span>{label}</span>
                        {dot && <span className='bn-dot'></span>}
                    </Link>
                )
            })}
            <button type='button' className='bn-item' onClick={onMenu}>
                <Menu size={24} color='#8f909c' />
                <span>Menu</span>
            </button>
        </nav>
    );
};

export default BottomNav;
